<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="企业名称" prop="companyName">
        <el-input v-model="dataForm.companyName" placeholder="企业名称"></el-input>
      </el-form-item>
      <el-form-item label="统一社会信用代码" prop="companyUnionCode">
        <el-input v-model="dataForm.companyUnionCode" placeholder="统一社会信用代码"></el-input>
      </el-form-item>
      <el-form-item label="法人" prop="legalEntity">
        <el-input v-model="dataForm.legalEntity" placeholder="法人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="telephone">
        <el-input v-model="dataForm.telephone" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item label="父级企业">
        <el-select v-model="dataForm.parentId" placeholder="请选择企业" style="width: 100%">
          <el-option
            v-for="item in companyOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="行业类型">
        <el-select v-model="dataForm.businessType" placeholder="请选择行业类型" style="width: 100%">
          <el-option
            v-for="item in businessOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="国家" prop="countryId">
        <el-select v-model="dataForm.countryId" @change="getProvinceOption" placeholder="请选择国家" style="width: 100%">
          <el-option
            v-for="item in countryOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省份">
        <el-select v-model="dataForm.provinceId" @change="getCityOption" placeholder="请选择省份" style="width: 100%">
          <el-option
            v-for="item in provinceOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市">
        <el-select v-model="dataForm.cityId" @change="getDistrictOption" placeholder="请选择城市" style="width: 100%">
          <el-option
            v-for="item in cityOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="区域">
        <el-select v-model="dataForm.districtId" placeholder="请选择区域" style="width: 100%">
          <el-option
            v-for="item in districtOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="dataForm.address" placeholder="地址"></el-input>
      </el-form-item>
      <el-form-item label="经度" prop="longitude">
        <el-input v-model="dataForm.longitude" placeholder="经度"></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="latitude">
        <el-input v-model="dataForm.latitude" placeholder="纬度"></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="dataForm.status" placeholder="请选择状态" style="width: 100%">
          <el-option
            v-for="item in enumOption"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      companyOption: [],
      enumOption: [],
      businessOption: [],
      countryOption: [],
      provinceOption: [],
      districtOption: [],
      cityOption: [],
      dataForm: {
        id: 0,
        companyUnionCode: '',
        companyName: '',
        legalEntity: '',
        telephone: '',
        businessType: '',
        areaId: '',
        position: '',
        address: '',
        parentId: '',
        status: '',
        countryId: '',
        provinceId: '',
        cityId: '',
      },
      dataRule: {
        // companyUnionCode: [
        //   {required: true, message: '统一社会信用代码不能为空', trigger: 'blur'}
        // ],
        companyName: [
          {required: true, message: '企业名称不能为空', trigger: 'blur'}
        ],
        // legalEntity: [
        //   {required: true, message: '法人不能为空', trigger: 'blur'}
        // ],
        // telephone: [
        //   {required: true, message: '联系电话不能为空', trigger: 'blur'}
        // ],
        countryId: [
          {required: true, message: '国家不能为空', trigger: 'blur'}
        ],
        businessType: [
          {required: true, message: '行业类型不能为空', trigger: 'blur'}
        ],
        // address: [
        //   {required: true, message: '地址不能为空', trigger: 'blur'}
        // ],
        parentId: [
          {required: true, message: '父级企业ID不能为空', trigger: 'blur'}
        ],
        status: [
          {required: true, message: '状态不能为空', trigger: 'blur'}
        ],
        longitude: [
          {required: true, message: '经度不能为空', trigger: 'blur'}
        ],
        latitude: [
          {required: true, message: '纬度不能为空', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    init(id) {
      this.getCompanyOption()
      this.getStatusOption()
      this.getBusinessOption()
      this.getCountryOption()
      this.dataForm = {}
      this.dataForm = {}
      this.companyOption = []
      this.countryOption = []
      this.provinceOption == []
      this.cityOption = []
      this.districtOption = []
      this.enumOption = []
      if (id) {//修改
        this.dataForm.id = id
        this.$nextTick(() => {
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl("/company/list"),
              method: 'get',
              params: this.$http.adornParams({
                'pageNum': 1,
                'pageSize': 1,
                id: id
              })
            }).then(({data}) => {
              if (data && data.code === 200) {
                let data_ = data.data.rows[0]
                if (data_) {
                  if (data_.countryId) this.getProvinceOption(data_.countryId)
                  if (data_.provinceId) this.getCityOption(data_.provinceId)
                  if (data_.cityId) this.getDistrictOption(data_.cityId)
                  this.dataForm = data_
                }
              }
            })
          }
        })
      } else {
        this.dataForm.id = null
      }
      this.dataForm.id = id || 0
      this.visible = true
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/company/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || undefined,
              'companyUnionCode': this.dataForm.companyUnionCode,
              'companyName': this.dataForm.companyName,
              'legalEntity': this.dataForm.legalEntity,
              'telephone': this.dataForm.telephone,
              'businessType': this.dataForm.businessType,
              'areaId': this.dataForm.areaId,
              'position': this.dataForm.position,
              'address': this.dataForm.address,
              'parentId': this.dataForm.parentId,
              // 'status': this.dataForm.status,
              'countryId': this.dataForm.countryId,
              'provinceId': this.dataForm.provinceId,
              'cityId': this.dataForm.cityId,
              'districtId': this.dataForm.districtId,
              "longitude": this.dataForm.longitude,
              "latitude": this.dataForm.latitude,
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    //获取企业option
    getCompanyOption() {
      this.$http({
        url: this.$http.adornUrl("/company/option"),
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.companyOption = data.data.companyOption
        }
      })
    },
    //获取状态
    getStatusOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/0"),
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.enumOption = data.data.enumOption
        }
      })
    },
    //获取行业类型
    getBusinessOption() {
      this.$http({
        url: this.$http.adornUrl("/configOption/option/7"),
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.businessOption = data.data.enumOption
        }
      })
    },
    //获取国家option
    getCountryOption() {
      this.$http({
        url: this.$http.adornUrl("/area/option/0"),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.countryOption = data.data.areaOption
        }
      })
    },
    //获取省份
    getProvinceOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.provinceOption = data.data.areaOption
        }
      })
    },
    //获取城市
    getCityOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.cityOption = data.data.areaOption
        }
      })
    },
    //获取区域
    getDistrictOption(selectValue) {
      this.$http({
        url: this.$http.adornUrl("/area/option/" + selectValue),
        method: 'get',
        params: this.$http.adornParams()
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.districtOption = data.data.areaOption
        }
      })
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/admincenter/company-add-or-update.vue